import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CartService {

  private cartQuantitySubject = new BehaviorSubject<number>(0);
  cartQuantity$ = this.cartQuantitySubject.asObservable();

  constructor() { }

  setCartQuantity(quantity: number) {
    this.cartQuantitySubject.next(quantity);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/cart.service.ts